import { extend } from '@11sight/extend';
import { DEFAULT_HELP_CENTRE_URL } from 'jitsi/base/config/constants';
export const TOOLBAR_BUTTONS = [
    'camera',
    'chat',
    'closedcaptions',
    'desktop',
    'audioOnly',
    'download',
    'embedmeeting',
    'etherpad',
    'feedback',
    'filmstrip',
    'fullscreen',
    'hangup',
    'help',
    'highlight',
    'invite',
    'linktosalesforce',
    'livestreaming',
    'microphone',
    'mute-everyone',
    'mute-video-everyone',
    'participants-pane',
    'profile',
    'raisehand',
    'recording',
    'security',
    'select-background',
    'select-background-circle',
    'settings',
    'shareaudio',
    'noisesuppression',
    'sharedvideo',
    'shortcuts',
    'stats',
    'tileview',
    'toggle-camera',
    'videoquality',
    'whiteboard',
];
export const THIRD_PARTY_PREJOIN_BUTTONS = ['microphone', 'camera', 'select-background-circle'];
export const TILE_VIEW_SMALL_HEIGHT_MARGIN = 30;
extend(DEFAULT_HELP_CENTRE_URL);
